export { useSelecionarTodosVinculos } from "./useSelecionarTodosVinculos";
